<template>
    <mini-button name="导入" @btnClick="whenImportClick">
        <i class="fa-solid fa-file-import"></i>

        <re-b-modal ref="import" header="导入" hide-footer
                    @hide="file=null">
            <div class="d-flex flex-column w-100">
                <b-form-file ref="upload"
                             accept=".xls,.xlsx"
                             v-model="file"
                             placeholder="请选择数据文件">
                </b-form-file>
                <b-button-group class="mt-1">
                    <mini-button :loading="downloading" @btnClick="downloadTemplate">
                        下载模版
                    </mini-button>
                    <mini-button :loading="importLoading" @btnClick="doImport">
                        导入
                    </mini-button>
                </b-button-group>
            </div>
        </re-b-modal>
    </mini-button>
</template>

<script>
import MiniButton from "@/components/common/buttons/MiniButton.vue";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal.vue";
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";

export default {
    name: "ExcelImportBtn",
    mixins: [emCommonUtilMixin],
    components: {ReBModal, MiniButton},
    props: {
        configId: [String, Number],
        service: String,
        formName: String,
        saveHolder: Object,
    },
    data() {
        return {
            file: null,
            downloading: false,
            importLoading: false,
        }
    },
    computed: {
        baseUri() {
            return `${process.env.VUE_APP_EM_GATEWAY_URL}/${this.service}/common`;
        },
        baseParam() {
            return `id=${this.configId}&formName=${this.formName}&locale=${this.$i18n.locale()}`;
        },
    },
    methods: {
        whenImportClick() {
            this.$refs.import.showModal();
        },
        downloadTemplate() {
            if (this.configId && this.service && this.formName) {
                this.downloading = true;
                let url = `${this.baseUri}/export/importTemplate?${this.baseParam}`;
                this.downloadWithHeader(url, "Import Template.xlsx", () => this.downloading = false);
            } else {
                this.$message.warning("Config Not Found")
            }
        },
        doImport() {
            if (this.file) {
                let param = new FormData();
                param.append('file', this.file);
                param.append('saveHolder', new Blob([JSON.stringify(this.saveHolder || {})], {type: 'application/json'}))
                this.importLoading = true;
                this.$store.dispatch('api/post', {
                    url: `${this.baseUri}/import/excel?${this.baseParam}`,
                    data: param
                }).then(() => {
                    this.$message.success('Import Success');
                    this.$refs.import.hide();
                    this.$emit('success');
                }).finally(() => this.importLoading = false);
            } else {
                this.$message.warning('No file chosen');
            }
        },
    }
}
</script>

<style scoped>
.w-100 >>> .b-form-file .custom-file-label {
    width: 100%;
}
</style>
